var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6206 1.60254C1.41732 1.60254 0.439026 2.58084 0.439026 3.78411V4.8749H20.0732V3.78411C20.0732 2.58084 19.0949 1.60254 17.8916 1.60254H2.6206ZM20.0732 8.14725H0.439026V14.692C0.439026 15.8952 1.41732 16.8735 2.6206 16.8735H17.8916C19.0949 16.8735 20.0732 15.8952 20.0732 14.692V8.14725ZM4.25678 12.5104H6.43835C6.73831 12.5104 6.98374 12.7558 6.98374 13.0558C6.98374 13.3558 6.73831 13.6012 6.43835 13.6012H4.25678C3.95681 13.6012 3.71138 13.3558 3.71138 13.0558C3.71138 12.7558 3.95681 12.5104 4.25678 12.5104ZM8.07453 13.0558C8.07453 12.7558 8.31995 12.5104 8.61992 12.5104H12.9831C13.283 12.5104 13.5285 12.7558 13.5285 13.0558C13.5285 13.3558 13.283 13.6012 12.9831 13.6012H8.61992C8.31995 13.6012 8.07453 13.3558 8.07453 13.0558Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6341,
    height: 17.4526,
    fill: "white",
    transform: "translate(0.438965 0.511719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCreditCard);
export default __webpack_public_path__ + "static/media/payment_credit_card.7db3372bc9c797a1d18e7529b8d9b04c.svg";
export { ForwardRef as ReactComponent };